const clinicSearchActionTypes = {
  getClinicList: 'clinicSearch/getClinicList',
  getClinicData: 'clinicSearch/getClinicData',
};

export default clinicSearchActionTypes;
